<template>
  <div>
    <div class="card card-user">
      <div class="card-body">
        <div class="form-group row">
          <label class="col-md-1 col-form-label">標題</label>
          <div class="col-md-10">
            <input v-model="vote.title" type="text" class="form-control">
          </div>
        </div>
      </div>
    </div>
    <div class="control">
      <h5>選項</h5>
      <div class="btns">
        <div class="btn btn-sm btn-success btn-icon" @click="minusRows"><i class="ti-minus" /></div>
        <div class="btn btn-sm btn-success btn-icon" v-text="rowsCount" />
        <div class="btn btn-sm btn-success btn-icon" @click="addRows"><i class="ti-plus" /></div>
      </div>
    </div>
    <div v-for="(row,i) in vote.options" :key="i" class="card card-user">
      <div class="card-body">
        <div class="btns ">
          <div class="btn btn-sm btn-success btn-icon" @click="minusRow(row)"><i class="ti-minus" /></div>
          <div class="btn btn-sm btn-success btn-icon" @click="addRow(row)"><i class="ti-plus" /></div>
        </div>
        <div class="form-group row">
          <label class="col-md-1 col-form-label">選項標題</label>
          <div class="col-md-10">
            <input v-model="row.title" type="text" class="form-control">
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-1 col-form-label">顯示顏色</label>
          <div class="col-md-10">
            <input v-model="row.color" type="text" class="form-control">
            <div class="colorList">
              <div
                v-for="(color,j) in $dataManager.getters.colorList"
                :key="j"
                class="color"
                :style="'background-color:'+color"
                @click="chooseColor(row,color)"
              >
                <span v-text="color" />
                <i v-if="color === row.color" class="ti-check-box" />
              </div>
            </div>
          </div>
        </div>
        <div v-for="(r,k) in row.keys" :key="k" class="form-group row">
          <label class="col-md-1 col-form-label">抓取內容</label>
          <div class="col-md-10">
            <input v-model="row.keys[k]" type="text" class="form-control">
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="update ml-auto mr-auto">
        <div class="btn btn-primary btn-round" @click="submit">送出</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Create',
  data: function() {
    return {
      vote: {
        title: '',
        options: [
          {
            title: '',
            color: '',
            keys: ['']
          }
        ]
      }

    }
  },
  computed: {
    rowsCount() {
      return this.vote.options.length
    }
  },
  methods: {
    addRows: function() {
      var row = {
        title: '',
        color: '',
        keys: ['']
      }
      if (this.vote.options.length < 25) {
        this.vote.options.push(row)
      }
    },
    minusRows: function() {
      if (this.vote.options.length > 1) {
        this.vote.options.pop()
      }
    },
    addRow: function(row) {
      var r = ''
      if (row.keys.length < 25) {
        row.keys.push(r)
      }
    },
    minusRow: function(row) {
      if (row.keys.length > 1) {
        row.keys.pop()
      }
    },
    chooseColor: function(row, color) {
      row.color = color
    },
    submit: function() {
      this.$store.commit('OPEN_LOADING')

      this.$store.dispatch('VoteCreate', { credentials: this.vote }).then((res) => {
        if (!res.errorCode) {
          this.$store.commit('CLOSE_LOADING')
          this.$router.push({ name: 'Vote.Detail', params: { id: res.data.id }})
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .control {
    display: flex;
    align-items: center;

    h5 {
      margin: 0;
    }

    .btns {
      margin-left: 3rem;
    }
  }

  .colorList {
    width: 100%;
    height: 50px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;

    .color {
      height: 30px;
      color: #ffffff;
      padding: 4px;
      position: relative;
      cursor: pointer;

      span {
        position: absolute;
        opacity: .4;
        font-size: .5rem;
      }

      i {
        position: absolute;
        right: 50%;
        font-size: 1rem;
        margin-right: -.5rem;
      }
    }
  }

  .btns {
    display: flex;
  }
</style>
